<!--
    Summary:
        hkml.exhibition.web - contact-us
    ChangeLog:
        wangn on 2020/11/28 added
-->
<template>
  <div class="v-contact-us" title="contact-us">
    <sub-banner id="id_about">
      <img src="../../assets/images/contact/p1.jpg"/>
      <div slot="title">
        {{$t('ContactUsText.p1_title')}}
      </div>
      <a href="/" slot="action">{{$t('ContactUsText.p1_action')}}</a>
    </sub-banner>

    <div class="content-wrapper">
      <contact-us-left></contact-us-left>
      <contact-us-right></contact-us-right>
    </div>
  </div>
</template>

<script>
  import SubBanner from "@/components/sub-banner";
  import ContactUsLeft from "./contact-us-left";
  import ContactUsRight from "./contact-us-right";

  export default {
    name: "contact-us",
    components: {ContactUsRight, ContactUsLeft, SubBanner},
  }
</script>

<style scoped lang="scss">
  .v-contact-us {
    /*background: url('../../assets/images/contact/bg.jpg') 26% bottom no-repeat;*/
    /*background-size: auto auto;*/
    background: url('../../assets/images/home/p2-bg.png') 290%  bottom no-repeat;
    background-size: auto auto;
    .content-wrapper {
      display: flex;
      padding:  3vw 11vw;
      justify-content: space-between;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/contact/contact-us.vue